import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import storage from '../../../utils/storage';
import { useSidebarConfig } from './useSidebarConfig';

export function useSidebarLogic(onClose) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Récupérer le rôle de l'utilisateur
  let userRole = storage.getRole();
  if (!userRole) {
    try {
      const decoded = storage.decodeToken();
      userRole = decoded?.role?.toLowerCase();
    } catch (error) {
      userRole = null;
    }
  } else {
    userRole = userRole.toLowerCase();
  }

  const links = useSidebarConfig(userRole);
console.log(links);

  const handleLinkClick = () => {
    // Fermer la sidebar seulement sur mobile après un clic
    if (window.innerWidth < 1024 && onClose) {
      onClose();
    }
  };

  const handleLogout = () => {
    storage.clearAll();
    navigate('/');
  };

  const handleSettings = () => {
    navigate('/profil');
    handleLinkClick();
  };

  // Afficher le sidebar pour tous les rôles authentifiés
  const shouldShowSidebar = userRole && links.length > 0;

  return {
    userRole,
    links,
    pathname,
    handleLinkClick,
    handleLogout,
    handleSettings,
    shouldShowSidebar,
  };
}
